<template>
    <div>
        <span>{{ $t('DifficultySelector.title') }}</span>
        <DifficultySelector />
    </div>
</template>   

<script>
import DifficultySelector from '@/components/DifficultySelector.vue'

export default {
    components: {
        DifficultySelector
    }
}
</script>
